/**
 * UserLvl
 * Enum representing user levels or roles.
 *
 * @property ADMIN - Admin user.
 * @property TEACHER - Teacher user.
 * @property STUDENT - Student user.
 */
export enum UserLvl {
  ADMIN = 2,
  TEACHER = 1,
  STUDENT = 0,
}
